<template>
  <Teleport to="body" v-if="showBubble && !showTaskSwitch && getAccessToken">
    <!-- 返回首页 -->
    <FloatingBubble class="bubbleStyle" v-model:offset="offset" axis="xy" magnetic="x" @click="openDrawer">
      <div class="back-index">
        <img src="@/assets/images/backIndex.png" alt="" srcset="" />
      </div>
    </FloatingBubble>
  </Teleport>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { storeToRefs } from 'pinia'
import { useTaskStore } from '@/stores/task'
import { useAuthStore } from '@/stores/login'
import { FloatingBubble } from 'vant'

// /examInfo
const excludeRouteList = [
  'ExamInfo',
  'surveyInfo',
  'surveyDetails',
  'trainingDetail',
  'courseDetail',
  'comDetailLevel',
  'broadcastDetail'
] // 需要展示悬浮球的各个详情页面路由 , 'rollVideo'
const route = useRoute()
const router = useRouter()
const { availWidth, availHeight } = window.screen
const offset = ref({ x: availWidth - 60, y: availHeight - 250 })
const path = route.name as string
const showBubble = ref(excludeRouteList.includes(path))
const taskStore = useTaskStore()
const { showTaskSwitch } = storeToRefs(taskStore)
const { getAccessToken } = storeToRefs(useAuthStore())

const openDrawer = () => {
  router.replace('/')
}

watch(
  () => route.name,
  (newVal) => {
    showBubble.value = excludeRouteList.includes(newVal)
  }
)
</script>

<style scoped lang="less">
.back-index {
  img {
    width: 48px;
    height: 48px;
    // box-shadow: 0px 3px 10px 0px rgba(80,80,80,0.13);
  }
}
</style>
